"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripeCheckoutSessionStatusResponseToJSON = exports.StripeCheckoutSessionStatusResponseFromJSONTyped = exports.StripeCheckoutSessionStatusResponseFromJSON = exports.instanceOfStripeCheckoutSessionStatusResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the StripeCheckoutSessionStatusResponse interface.
 */
function instanceOfStripeCheckoutSessionStatusResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStripeCheckoutSessionStatusResponse = instanceOfStripeCheckoutSessionStatusResponse;
function StripeCheckoutSessionStatusResponseFromJSON(json) {
    return StripeCheckoutSessionStatusResponseFromJSONTyped(json, false);
}
exports.StripeCheckoutSessionStatusResponseFromJSON = StripeCheckoutSessionStatusResponseFromJSON;
function StripeCheckoutSessionStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'paymentStatus': !(0, runtime_1.exists)(json, 'paymentStatus') ? undefined : json['paymentStatus'],
    };
}
exports.StripeCheckoutSessionStatusResponseFromJSONTyped = StripeCheckoutSessionStatusResponseFromJSONTyped;
function StripeCheckoutSessionStatusResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': value.status,
        'paymentStatus': value.paymentStatus,
    };
}
exports.StripeCheckoutSessionStatusResponseToJSON = StripeCheckoutSessionStatusResponseToJSON;
